import React from 'react';
import type { FacetHandlerProps, SearchResult } from '../../../types';
import CheckboxComponent, { Checked } from '../../Checkbox';

function checkboxFactory(invert: boolean = false) {
  return function Checkbox(
    props: FacetHandlerProps<SearchResult, { id: string; name: string }>
  ): JSX.Element {
    const { facet, filters } = props;
    const selected = filters[facet.index];

    const value = invert
      ? // if it's null, we also want it to be unchecked
        selected !== false
        ? Checked.FALSE
        : Checked.TRUE
      : selected
      ? Checked.TRUE
      : Checked.FALSE;

    return (
      <CheckboxComponent
        onChange={e => {
          const value = e.currentTarget.checked;
          props.onChange(facet.index, invert ? !value : value);
        }}
        value={value}
      >
        {facet.label}
      </CheckboxComponent>
    );
  };
}

const Checkbox = checkboxFactory();

export default Checkbox;
export const CheckboxInverse = checkboxFactory(true);
